module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/en/1/3-0505142aa5b7219364452f3074f62d16.jpg";